<template>
  <div class="wrapper">
    <div class="filter white_box">
      <!-- <p class="font_14_black">当前组织：</p> -->
      <!-- 选择&搜索框 -->
      <!-- <el-select
        class="custom-os"
        v-model="selectedValue"
        filterable
        default-first-option
        size="medium"
        placeholder="公司名称"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select> -->

      <p class="font_14_black">薪资月份：</p>
      <el-date-picker 
        class="custom-mc" 
        v-model="salaryDateRange" 
        type="monthrange" 
        range-separator="至" 
        start-placeholder="开始月份" 
        end-placeholder="结束月份" 
        value-format="yyyy-MM"
        format="yyyy-MM"
        start-placeholder-format="yyyy-MM"
        end-placeholder-format="yyyy-MM"
      ></el-date-picker>
      <!-- 查询&重置按钮 -->
      <button-a color="#f26828" class="query" @click.native="query()">查询</button-a>
      <button-a color="#08a752" @click.native="reset()">重置</button-a>
    </div>

    <!-- 统计 -->
    <div class="sum-group white_box">
      <sum title="本月发薪次数" :num="count" num_up>
        <img class="icon" src="@/assets/icons/Incumbency@2x.png" alt />
      </sum>
      <sum title="本月发薪人数" :num="peopleCount" num_up>
        <img class="icon" src="@/assets/icons/Payrollthismonth@2x.png" alt />
      </sum>
      <sum title="本月发薪总金额" :amount="salaryCount" num_up>
        <img class="icon" src="@/assets/icons/Providentfundinsurance@2x.png" alt />
      </sum>
    </div>

    <div class="result white_box">
      <!-- 表格
        ref="multipleTable" 引用名
        :data="tableData" 绑定数据
        :header-row-style="headerRowStyle" 表头样式
        :row-style="rowStyle" 行样式
      -->
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        :header-row-style="{height: translateWidth(68)+'px', fongSize: '14px', color: '#000', backgroundColor: '#fafbff'}"
        :header-cell-style="{backgroundColor: 'transparent'}"
        :row-style="{height: translateWidth(60)+'px', backgroundColor: '#fff'}"
        style="width: 100%;font-size: 14px;color: #707070;border: 1px solid #e5e5e5;border-radius: 6px"
        @row-click="handleRowClick"
        @row-dblclick="handleRowDblclick"
        @row-mousedown="handleRowMousedown"
        @row-mousemove="handleRowMousemove"
        @row-mouseup="handleRowMouseup"
      >
        <!-- 占位列 -->
        <el-table-column :width="tableWidth[0] | translateWidth"></el-table-column>
        <!-- 多选框 -->

        <el-table-column type="index" label="序号" :width="tableWidth[1] | translateWidth"></el-table-column>
        <el-table-column prop="customerName" label="所属企业"  :width="tableWidth[2] | translateWidth" show-overflow-tooltip></el-table-column>
        <el-table-column prop="salarySummaryName" label="薪资批次名称" :width="tableWidth[3] | translateWidth" show-overflow-tooltip></el-table-column>
        <el-table-column prop="salaryDate" label="薪资月份" :width="tableWidth[4] | translateWidth" show-overflow-tooltip></el-table-column>
        <el-table-column prop="personNumber" label="批次总人数" :width="tableWidth[5] | translateWidth" show-overflow-tooltip></el-table-column>
        <el-table-column prop="successfulPayNumber" label="发放成功人数" :width="tableWidth[6] | translateWidth" show-overflow-tooltip></el-table-column>
        <el-table-column prop="refundNumber" label="退票人数" :width="tableWidth[7] | translateWidth" show-overflow-tooltip></el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <span class="font_14_orange pointer view" @click="view(scope.row)">查看</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, prev, pager, next, sizes, jumper, ->, slot"
        :total="total"
        :pager-count="5"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { Get } from "@/js/http.js";
import { dateConvert, translateWidth } from "@/js/tool.js";

export default {
  name: "SalaryBatches",
  components: {},
  props: {},
  data() {
    return {
      tableWidth: [35, 94, 270, 322, 150, 164, 178, 176],

      salaryDateRange: [], // 薪资月份范围
      options: [
        // 组织搜索框
        // {
        //   value: "HTML",
        //   label: "HTML"
        // },
      ],
      selectedValue: "", // 选择的组织id
      page: 1, // 当前页码
      size: 10, // 每页条数
      total: 0, // 总条数
      tableData: [], // 表格数据
      count: 0,
      peopleCount: 0,
      salaryCount: 0,
      
      // 交互相关
      clickTimer: null, // 单击定时器
      isDragging: false, // 是否正在拖动
      isDoubleClick: false // 是否双击
    };
  },
  watch: {},
  computed: {
    // 查询表格跳过的条数
    SkipCount() {
      return (this.page - 1) * this.size;
    }
  },
  methods: {
    // 获取组织数据
    getOptions() {
      Get("api/v1/customers/selectors").then(({ data }) => {
        this.options = data;
      });
    },
    // 获取表格数据
    getData() {
      // 处理薪资月份范围
      let salaryDateRange = this.salaryDateRange || [null, null]
      
      Get("api/v1/salary-summaries", {
        customerId: this.selectedValue || "", // 客户ID
        SalaryDateBegin: salaryDateRange[0], // 薪资月份起始
        SalaryDateEnd: salaryDateRange[1], // 薪资月份结束
        MaxResultCount: this.size, // 每页条数
        SkipCount: this.SkipCount // 跳过条数
      })
        .then(res => {
          this.total = res.data.totalCount;
          this.tableData = res.data.items;
        })
        .catch(() => {
        });
    },
    getSumGroup() {
      Get("api/v1/salary-summaries/current-month", {
        // customerId: this.selectedValue || "",
        // salaryDate: this.month ? this.date(this.month) : ""
      })
        .then(res => {
          this.count = res.data.statistics["本月发薪次数"] || 0;
          this.peopleCount = res.data.statistics["本月发薪人数"] || 0;
          this.salaryCount = res.data.statistics["本月发薪总金额"] || 0;
        })
        .catch(() => {
        });
    },
    // 点击查询按钮
    query() {
      this.page = 1;
      this.getData();
      this.getSumGroup();
    },
    // 重置
    reset() {
      this.selectedValue = "";
      this.salaryDateRange = [];
      this.page = 1;
      this.getData();
      this.getSumGroup();
    },
    // 每页条数选择
    handleSizeChange(v) {
      this.size = v;
      this.getData();
    },
    // 页码选择
    handleCurrentChange(v) {
      this.page = v;
      this.getData();
    },
    // 日期格式转换
    date(dateStr) {
      return dateConvert(dateStr);
    },
    // 处理行点击（支持双击取消跳转、拖动选中不跳转）
    handleRowClick(item) {
      if (this.isDragging || this.isDoubleClick) {
        this.isDoubleClick = false;
        return;
      }
      if (this.clickTimer) {
        clearTimeout(this.clickTimer);
      }
      this.clickTimer = setTimeout(() => {
        this.view(item);
        this.clickTimer = null;
      }, 300);
    },
    // 处理双击
    handleRowDblclick(item) {
      if (this.clickTimer) {
        clearTimeout(this.clickTimer);
        this.clickTimer = null;
      }
      this.isDoubleClick = true;
      this.copyRowData(item);
    },
    // 处理鼠标按下
    handleRowMousedown() {
      this.isDragging = false;
    },
    // 处理鼠标移动
    handleRowMousemove() {
      this.isDragging = true;
    },
    // 处理鼠标释放
    handleRowMouseup() {
      setTimeout(() => {
        this.isDragging = false;
      }, 100);
    },
    // 复制行数据文本
    copyRowData(item) {
      const rowText = `所属企业: ${item.customerName || ''}\n薪资批次名称: ${item.salarySummaryName || ''}\n薪资月份: ${item.salaryDate || ''}\n批次总人数: ${item.personNumber || ''}\n发放成功人数: ${item.successfulPayNumber || ''}\n退票人数: ${item.refundNumber || ''}`;
      
      navigator.clipboard.writeText(rowText).then(() => {
        this.$message.success('已复制整行数据');
      }).catch(() => {
        const textarea = document.createElement('textarea');
        textarea.value = rowText;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        this.$message.success('已复制整行数据');
      });
    },
    // 查看
    view(item) {
      console.log('view - item 数据:', item);
      // 尝试获取薪资批次ID，可能是 id、pkid 或 salarySummaryId
      const salarySummaryId = item.id || item.pkId || item.salarySummaryId;
      console.log('view - 获取到的 salarySummaryId:', salarySummaryId);
      
      if (!salarySummaryId) {
        this.$message.error('无法获取薪资批次ID');
        return;
      }
      
      // 使用 path 跳转，确保参数正确传递
      this.$router.push({
        path: `/SalaryBatches/${salarySummaryId}`
      });
    },
    translateWidth(num) {
      return translateWidth(num)
    },
    // 绑定窗口缩放事件
    ifResize() {
      window.addEventListener("resize", this.resize);
    },
    resize() {
      this.tableWidth = JSON.parse(JSON.stringify(this.tableWidth))
    }
  },
  created() {},
  mounted() {
    this.getOptions();
    this.getData();
    this.getSumGroup();
  },
  activated() {
    this.ifResize();
  },
  deactivated() {
    // 解除事件
    window.removeEventListener('resize', this.resize)
  },
};
</script>
<style lang="scss" scoped>
// 布局样式
.wrapper {
  padding: 150px 32px 24px;
  > div {
    margin-bottom: 32px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .filter {
    display: flex;
    align-items: center;
    padding: 22px 48px;
    gap: 16px;
    flex-wrap: wrap;
    position: fixed;
    top: 70px;
    left: 11.6vw;
    right: 0;
    z-index: 100;
    background-color: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    max-width: calc(100% - 11.6vw);
    border: 1px solid #e5e5e5;
    border-radius: 6px;
    
    .font_14_black {
      margin: 0;
      white-space: nowrap;
    }
    
    .custom-mc {
      min-width: 300px;
    }
  }
  .tags {
    padding: 48px;
    .tag-group {
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .options {
      flex: 1;
      div {
        width: 100%;
        display: flex;
        justify-content: flex-end;
      }
    }
  }
  .sum-group {
    display: flex;
    padding: 24px 48px 24px;
    align-items: center;
    .sum {
      width: 240px;
      &:last-of-type {
        flex: 1;
      }
    }
  }
  .result {
    padding: 30px 48px 48px;
  }
}
</style>